export default {
  EmptyState: {
    title: 'Lisää ensimmäinen ravintolasi',
    description:
      'Sinulla ei ole vielä yhtään ravintolaa. Luo yksi aloittaaksesi sen asetukset ja tilausten vastaanottamisen.',
    cta: 'Uusi ravintola',
  },
};
